import { render, staticRenderFns } from "./promo-calculator.vue?vue&type=template&id=37aee700"
import script from "./promo-calculator.vue?vue&type=script&lang=js"
export * from "./promo-calculator.vue?vue&type=script&lang=js"
import style0 from "./promo-calculator.vue?vue&type=style&index=0&id=37aee700&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports